import { STORAGE_KEY_AUTH_TOKEN } from "./constants";

export const getToken = () => {
  const { jwt = '' } = JSON.parse(localStorage.getItem(STORAGE_KEY_AUTH_TOKEN)) || {};
  return jwt
}
